import z from "zod";
import { zPipelineStateReq } from "./z-pipe-settings";
import { zRV3 } from "./z-rv3";

const zMessagePart = z.object({ type: z.string() }).passthrough();

const zChatMessage = z.object({
	id: z.string(),
	role: z.enum(["system", "user", "assistant"]),
	parts: z.array(zMessagePart),
});

export const zChat = z.object({
	id: z.string().uuid(),
	layoutId: z.string().uuid(),
	messages: z.array(zChatMessage),
	isComment: z.boolean(),
	position: zRV3.optional(),
	dir: zRV3.optional(),
});

const zChatContext = z.object({
	pipeSettings: zPipelineStateReq,
	metrics: z.object({
		siteArea: z.number(),
		buildingCount: z.number(),
		apartmentCount: z.number(),
		buildingFootprintArea: z.number(),
		layoutEfficiency: z.number(),
		gsi: z.number(),
		gfa: z.number(),
		nia: z.number(),
		far: z.number(),
		avr: z.number(),
		unitMix: z.array(
			z.object({
				name: z.string(),
				color: z.string(),
				count: z.number(),
			}),
		),
	}),
	buildings: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			maxLevels: z.number(),
		}),
	),
	commentAttachedToBuildingId: z.string().optional(),
});

export type ChatContext = z.infer<typeof zChatContext>;

export const zChatReq = z.object({
	messages: z.array(zChatMessage),
	context: zChatContext,
});
